export default __webpack_public_path__ + "static/media/delBoy.4f4d233c.jpg";